import { NgModule } from "@angular/core";
import { PriceRoutes } from "./price.routes";
import { PriceEstimativaListComponent } from "./price-estimativa-list.component";
import { PriceEstimativaComponent } from "./price-estimativa.component";
import { PriceProjetoDialogComponent } from "./price-projeto-dialog.component";
import { EstimativaFormComponent } from "../estimativa/estimativa-form.component";
import { PriceResumoComponent } from "../price/price-resumo.component";
import { FaturamentoListComponent } from "../faturamento/faturamento-list.component";
import { FaturamentoFormComponent } from "../faturamento/faturamento-form.component";
import { PriceEstimativaResumoComponent } from "./price-estimativa-resumo.component";
import { AnexoModalComponent } from "../anexo/anexo.modal.component";
import { AnexoListComponent } from "../anexo/anexo-list.component";
import { ConfirmComponent } from "../util/confirm/confirm.component";
import { ComentarioFormComponent } from "../comentario/comentario-form.component";
import { ComentarioListComponent } from "../comentario/comentario-list.component";
import { PriceEditarValorComponent } from "./price-editar-valor.component";
import { NgxCurrencyModule } from "ngx-currency";
import { SharedModule } from "src/app/shared/shared.module";
import { EstimativaAprovarFormComponent } from "../estimativa/estimativa-aprovar-form.component";
import { RequisitoModule } from "../requisito/requisito.module";
import { EquipeModule } from "../equipe/equipe.module";
import { PlanejamentoModule } from "../planejamento/planejamento.module";
import { BodyShopModule } from "../bodyshop/bodyshop.module";
import { EstimativaDuplicarComponent } from "../estimativa/estimativa-duplicar.component";
import { CustoAdicionalComponent } from "../custo-adicional/custo-adicional.component";
import { MatDialogModule } from "@angular/material/dialog";
import { EstimativaModule } from "../estimativa/estimativa.module";
import { PriceBodyShopResumoComponent } from "./priceBodyShopResumo/priceBodyShopResumo.component";
import { PriceEditaValorAdotadoComponent } from "./price-edita-valor-adotado/price-edita-valor-adotado.component";
import { PriceEstimativaExcluirDialogComponent } from "./price-estimativa-excluir-dialog/price-estimativa-excluir-dialog.component";
import { AbaParceirosComponent } from "../aba-parceiros/aba-parceiros.component";
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CronogramaEstimativaComponent } from '../cronograma-estimativa/cronograma-estimativa.component';
import { StaffPlanProjetoModule } from '../staff-plan-projeto/staff-plan-projeto.module';
import { AdicionarCronogramaKeyDialogComponent } from "../cronograma-estimativa/adicionar-cronograma-key-dialog/adicionar-cronograma-key-dialog.component";
import { PriceSimulacaoComponent } from "./price-simulacao-list.component";
import { MatFormFieldModule } from "@angular/material/form-field";

export const customCurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$",
  suffix: "",
  thousands: ".",
  nullable: true,
};

@NgModule({
  declarations: [
    PriceEstimativaListComponent,
    PriceEstimativaComponent,
    PriceProjetoDialogComponent,
    EstimativaFormComponent,
    PriceResumoComponent,
    FaturamentoListComponent,
    FaturamentoFormComponent,
    PriceEstimativaResumoComponent,
    AnexoModalComponent,
    AnexoListComponent,
    ConfirmComponent,
    ComentarioFormComponent,
    ComentarioListComponent,
    PriceEditarValorComponent,
    EstimativaAprovarFormComponent,
    EstimativaDuplicarComponent,
    CustoAdicionalComponent,
    PriceBodyShopResumoComponent,
    PriceEditaValorAdotadoComponent,
    PriceEstimativaExcluirDialogComponent,
    AbaParceirosComponent,
    CronogramaEstimativaComponent,
    AdicionarCronogramaKeyDialogComponent,
    PriceSimulacaoComponent
  ],
  imports: [
    SharedModule,
    PriceRoutes,
    RequisitoModule,
    MatFormFieldModule,
    EquipeModule,
    PlanejamentoModule,
    BodyShopModule,
    MatDialogModule,
    EstimativaModule,
    StaffPlanProjetoModule,
    MatSliderModule,
    MatSlideToggleModule,
    DragDropModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
  ],
})
export class PriceModule { }
